import _ from 'lodash'

import routeParams from 'helpers/routeParams'
import { sameIdsIn } from 'utils/array'

const GET_TASKS_AWARD_LEADERS =
  'dofe-bo/tasksAwardLeaders/GET_TASKS_AWARD_LEADERS'
const GET_TASKS_AWARD_LEADERS_SUCCESS =
  'dofe-bo/tasksAwardLeaders/GET_TASKS_AWARD_LEADERS_SUCCESS'
const GET_TASKS_AWARD_LEADERS_FAIL =
  'dofe-bo/tasksAwardLeaders/GET_TASKS_AWARD_LEADERS_FAIL'
const SET_TASKS_AWARD_LEADERS_SELECTED =
  'dofe-bo/tasksAwardLeaders/SET_TASKS_AWARD_LEADERS_SELECTED'
const TOGGLE_TASKS_AWARD_LEADERS_ALL_SELECTED =
  'dofe-bo/tasksAwardLeaders/TOGGLE_TASKS_AWARD_LEADERS_ALL_SELECTED'
const EXPORT_TASKS_AWARD_LEADERS =
  'dofe-bo/tasksAwardLeaders/EXPORT_TASKS_AWARD_LEADERS'
const EXPORT_TASKS_AWARD_LEADERS_SUCCESS =
  'dofe-bo/tasksAwardLeaders/EXPORT_TASKS_AWARD_LEADERS_SUCCESS'
const EXPORT_TASKS_AWARD_LEADERS_FAIL =
  'dofe-bo/tasksAwardLeaders/EXPORT_TASKS_AWARD_LEADERS_FAIL'
const SET_FILTER = 'dofe-bo/tasksAwardLeaders/SET_FILTER'
const SET_BASE_FILTER = 'dofe-bo/tasksAwardLeaders/SET_BASE_FILTER'
const SET_PARAMS = 'dofe-bo/tasksAwardLeaders/SET_PARAMS'
const SET_DISABLED_CACHE = 'dofe-bo/tasksAwardLeaders/SET_DISABLED_CACHE'
const REMOVE_DETAIL_DATA = 'dofe-bo/tasksAwardLeaders/REMOVE_DETAIL_DATA'
const CONFIRM_AWARD_LEADER_EMAIL =
  'dofe-bo/tasksAwardLeaders/CONFIRM_AWARD_LEADER_EMAIL'
const CONFIRM_AWARD_LEADER_EMAIL_SUCCESS = `${CONFIRM_AWARD_LEADER_EMAIL}_SUCCESS`
const CONFIRM_AWARD_LEADER_EMAIL_FAIL = `${CONFIRM_AWARD_LEADER_EMAIL}_FAIL`

const BULK_APPROVE_AWARD_LEADERS_RESET =
  'dofe-bo/tasksAwardLeaders/BULK_APPROVE_AWARD_LEADERS_RESET'
const BULK_APPROVE_AWARD_LEADERS =
  'dofe-bo/tasksAwardLeaders/BULK_APPROVE_AWARD_LEADERS'
const BULK_APPROVE_AWARD_LEADERS_SUCCESS =
  'dofe-bo/tasksAwardLeaders/BULK_APPROVE_AWARD_LEADERS_SUCCESS'
const BULK_APPROVE_AWARD_LEADERS_FAIL =
  'dofe-bo/tasksAwardLeaders/BULK_APPROVE_AWARD_LEADERS_FAIL'

const initialState = {
  list: [],
  detail: {},
  sort: '',
  offset: 0,
  limit: 20,
  pages: 1,
  count: null,
  filter: '',
  invalidate: null,
  loading: false,
  loaded: false,
  selectedIds: [],
  bulkApprove: {
    loading: false,
    loaded: false
  }
}

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case GET_TASKS_AWARD_LEADERS:
      return {
        ...state,
        loading: true
      }
    case GET_TASKS_AWARD_LEADERS_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        list: action.result,
        count: Number(action.headers['x-total-count']),
        pages: Math.ceil(
          Number(action.headers['x-total-count']) / state.limit
        ) || state.pages
      }
    case GET_TASKS_AWARD_LEADERS_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      }
    case SET_TASKS_AWARD_LEADERS_SELECTED:
      return {
        ...state,
        selectedIds: action.selectedIds
      }
    case TOGGLE_TASKS_AWARD_LEADERS_ALL_SELECTED:
      if (sameIdsIn(action.selectedIds, action.selectableIds)) {
        return {
          ...state,
          selectedIds: []
        }
      }

      return {
        ...state,
        selectedIds: [...action.selectableIds]
      }
    case SET_FILTER:
      return Object.assign({}, state, {
        filter: action.filterBy,
        invalidate: new Date().getTime()
      })
    case SET_BASE_FILTER:
      return Object.assign({}, state, {
        baseFilter: action.filterBy,
        invalidate: new Date().getTime()
      })
    case SET_PARAMS:
      return {
        ...state,
        limit: action.options.limit !== undefined
          ? action.options.limit
          : state.limit,
        offset: action.options.offset !== undefined
          ? action.options.offset
          : state.offset,
        filter: action.options.filter !== undefined
          ? action.options.filter
          : state.filter,
        sort: action.options.sort !== undefined
          ? action.options.sort
          : state.sort,
        invalidate: _.isEmpty(action.options)
          ? state.invalidate
          : new Date().getTime()
      }
    case SET_DISABLED_CACHE:
      return Object.assign({}, state, {
        loaded: false
      })
    case REMOVE_DETAIL_DATA:
      return Object.assign({}, state, {
        detail: {}
      })
    case BULK_APPROVE_AWARD_LEADERS_RESET:
      return {
        ...state,
        bulkApprove: {
          loading: false,
          loaded: false
        }
      }
    case BULK_APPROVE_AWARD_LEADERS:
      return {
        ...state,
        bulkApprove: {
          ...state.bulkApprove,
          loading: true,
          loaded: false
        }
      }
    case BULK_APPROVE_AWARD_LEADERS_SUCCESS:
      return {
        ...state,
        bulkApprove: {
          ...state.bulkApprove,
          loading: false,
          loaded: true,
          detail: action.result
        }
      }
    case BULK_APPROVE_AWARD_LEADERS_FAIL:
      return {
        ...state,
        bulkApprove: {
          ...state.bulkApprove,
          loading: false,
          error: action.error
        }
      }
    default:
      return state
  }
}

export function getTasksRegistrationAwardLeaders(params = {}, baseFilter) {
  return {
    types: [
      GET_TASKS_AWARD_LEADERS,
      GET_TASKS_AWARD_LEADERS_SUCCESS,
      GET_TASKS_AWARD_LEADERS_FAIL
    ],
    promise: client =>
      client.get(
        `api/tasks/award-leader-registration-approval?with=LABELS,LEADER${routeParams(params, baseFilter)}`
      )
  }
}

export function setTasksAwardLeadersSelected(selectedIds) {
  return {
    type: SET_TASKS_AWARD_LEADERS_SELECTED,
    selectedIds
  }
}

export function toggleTasksAwardLeadersAllSelected(selectedIds, selectableIds) {
  return {
    type: TOGGLE_TASKS_AWARD_LEADERS_ALL_SELECTED,
    selectedIds,
    selectableIds
  }
}

export function exportTasksRegistrationAwardLeaders(params = {}, baseFilter) {
  return {
    types: [
      EXPORT_TASKS_AWARD_LEADERS,
      EXPORT_TASKS_AWARD_LEADERS_SUCCESS,
      EXPORT_TASKS_AWARD_LEADERS_FAIL
    ],
    promise: client =>
      client.get(
        `api/tasks/award-leader-registration-approval?with=LABELS,LEADER${routeParams({ filter: params.filter }, baseFilter)}`
      )
  }
}

export function setAwardLeadersFilter(filterBy) {
  return {
    type: SET_FILTER,
    filterBy
  }
}

export function setAwardLeadersBaseFilter(filterBy) {
  return {
    type: SET_BASE_FILTER,
    filterBy
  }
}

export function setAwardLeadersParams(options) {
  return {
    type: SET_PARAMS,
    options
  }
}

export function removeAwardLeadersDetailData() {
  return {
    type: REMOVE_DETAIL_DATA
  }
}

export function removeAwardLeadersCache() {
  return {
    type: SET_DISABLED_CACHE
  }
}

export function confirmAwardLeaderEmail(value = false, leaderId) {
  return {
    types: [
      CONFIRM_AWARD_LEADER_EMAIL,
      CONFIRM_AWARD_LEADER_EMAIL_SUCCESS,
      CONFIRM_AWARD_LEADER_EMAIL_FAIL
    ],
    promise: client =>
      client.post(
        `api/award-leader-registration/${leaderId}/email-confirmation`,
        {
          data: { value }
        }
      )
  }
}

export function bulkApproveAwardLeadersReset() {
  return {
    type: BULK_APPROVE_AWARD_LEADERS_RESET
  }
}

export function bulkApproveAwardLeaders(awardLeaderRegistrationIds) {
  return {
    types: [
      BULK_APPROVE_AWARD_LEADERS,
      BULK_APPROVE_AWARD_LEADERS_SUCCESS,
      BULK_APPROVE_AWARD_LEADERS_FAIL
    ],
    promise: client =>
      client.post(
        'api/award-leader-registration-approval/bulk',
        {
          data: {
            awardLeaderRegistrationIds
          }
        }
      )
  }
}
